import { Workbox } from 'workbox-window';
import Swal from 'sweetalert2';
import { APP_VERSION, RELEASE_NOTES } from './version';

export default function registerServiceWorker() {

  if ('production' !== process.env.NODE_ENV) {
    return;
  }
  // Check if the serviceWorker Object exists in the navigator object ( means if browser supports SW )
  if ('serviceWorker' in navigator) {
    const wb = new Workbox('sw.js');

    wb.addEventListener('installed', event => {
      /**
       * We have the condition - event.isUpdate because we don't want to show
       * this message on the very first service worker installation,
       * only on the updated
       */
      if (event.isUpdate) {

        let releaseNotesHtml = '';
        if (RELEASE_NOTES && RELEASE_NOTES.length > 0) {
          releaseNotesHtml = `
                <div style="margin-top: 15px; border-top: 1px solid #eee; padding-top: 10px;">
                    <strong style="color: #333;">Novedades en v${APP_VERSION}:</strong>
                    <ul style="text-align: left; margin-top: 5px; padding-left: 20px; color: #555; font-size: 0.9em;">
                        ${RELEASE_NOTES.map(note => `<li>${note}</li>`).join('')}
                    </ul>
                </div>
            `;
        }

        Swal.fire({
          title: `¡Actualización v${APP_VERSION} Disponible!`,
          html: `
            <div style="text-align: left;">
              <p><strong>Se ha detectado una nueva versión de la aplicación.</strong></p>
              <p>Para disfrutar de las últimas mejoras y correcciones, es necesario recargar la página.</p>
              ${releaseNotesHtml}
            </div>
          `,
          icon: 'info',
          showCancelButton: true,
          confirmButtonText: '<i class="material-icons" style="font-size: 16px; vertical-align: middle; margin-right: 5px;">refresh</i> Actualizar ahora',
          cancelButtonText: 'Más tarde',
          confirmButtonColor: '#0F45C7',
          cancelButtonColor: '#6c757d',
          reverseButtons: true,
          allowOutsideClick: false,
          customClass: {
            popup: 'update-notification-popup',
            confirmButton: 'btn-update-confirm',
            cancelButton: 'btn-update-cancel'
          }
        }).then((result) => {
          if (result.isConfirmed) {
            // Show loading state before reload
            Swal.fire({
              title: 'Actualizando...',
              html: 'Por favor espera mientras se recarga la aplicación.',
              icon: 'info',
              allowOutsideClick: false,
              allowEscapeKey: false,
              showConfirmButton: false,
              didOpen: () => {
                Swal.showLoading();
              }
            });
            // Reload after a short delay to show the loading state
            setTimeout(() => {
              window.location.reload();
            }, 500);
          }
        });
      }
    });

    wb.register();
  }
}
